import { useQueryClient } from 'react-query';

import { usePost } from '../../utils/reactQuery';
import { ApiRoutesEnum } from '../../utils/routes';

export const useSaveRecruitmentFilter = () => {
  const queryClient = useQueryClient();
  return usePost({
    url: ApiRoutesEnum.recruitmentsSaveFilter,
    onSuccess: () => {
      queryClient.invalidateQueries([ApiRoutesEnum.recruitmentsFilters]);
    },
  });
};
